import { useCallback } from "react"
import type { UserToken } from "../../types/UserToken"

interface UseUserProfileProps {
  userToken: UserToken | null
}

export const useUserProfile = ({ userToken }: UseUserProfileProps) => {
  // Get the current user's profile ID
  const getUserProfileId = useCallback(() => {
    if (!userToken?.user?.profiles || userToken.user.profiles.length === 0) {
      console.error("No hay perfiles disponibles en el token de usuario")
      return undefined
    }
    // Buscar primero un perfil con rol "Broker"
    const brokerProfile = userToken.user.profiles.find((profile) => profile.roleName === "Broker")
    if (brokerProfile) {
      return brokerProfile.id
    }

    // Si no hay perfil de Broker, buscar un perfil con rol "Cliente"
    const clientProfile = userToken.user.profiles.find((profile) => profile.roleName === "Cliente")
    if (clientProfile) {
      return clientProfile.id
    }

    // Si no se encuentra ninguno de los roles específicos, usar el primer perfil disponible
    return userToken.user.profiles[0].id
  }, [userToken])

  const userProfileId = getUserProfileId()

  return {
    getUserProfileId,
    userProfileId,
  }
}
